class INTENT.utils.Template
  @get_table: (headrows = '', bodyrows = '') ->
    """
    <table class="table table-stripped table-condensed">
      <thead>
        <tr>
          #{headrows}
        </tr>
      </thead>
      <tbody>
          #{bodyrows}
      </tbody>
    </table>
    """

  @get_tr_row: (value, _class = '') ->
    _class = @get_class_attr _class
    "<tr#{_class}>#{value}</tr>"

  @get_th_row: (value) ->
    "<th>#{value}</th>"

  @get_td_row: (value, attrs = {}) ->
    attrs = @get_attrs attrs
    "<td#{attrs}>#{value}</td>"

  @wrap_in_p: (value, attrs = {}) ->
    attrs = @get_attrs attrs
    "<p#{attrs}>#{value}</p>"

  @wrap_in_div: (value) ->
    "<div>#{value}</div>"

  @btn: (attrs = {}) ->
    $("<button/>", attrs)[0].outerHTML

  @wrap_link: (url, name = '', _class = '', _target = '') =>
    _class = @get_class_attr _class
    if _target
      _target = " target='#{_target}'"
    "<a#{_class} href='#{url}'#{_target}>#{name}</a>"

  @get_class_attr: (_class = '') ->
    if _class != ''
      _class = " class='#{_class}'"
    return _class

  @get_attrs: (attrs={}) ->
    result = ''
    $.each attrs, (an, av) ->
      result += " #{an}='#{av}'"
    result
